
export const AccountRestrictionCodes = {
    stonexTraderRestriction: 'StoneX Trader Restriction'
}
